import React, { useState } from "react";
import PropTypes from "kf-proptypes/widgets";

import { isEmpty } from "base/utils";

import { DropDownWrapper, NoResultsFound } from "./index.jsx";
import { SearchWidget } from "./search.widget.jsx";
import { Checkbox } from "../../checkbox/index.jsx";

import styles from "./multiselect.css";

export function MultiSelectWidget(props) {
  let {
    value,
    onSearch,
    searchAutoFocus = false,
    labelRenderer,
    dataSource = null,
    onChange = () => {},
    compareBy
  } = props;
  let [dataSourceType] = useState(checkDataSourceType(dataSource));
  let [initialValues] = useState(value ? value : []);
  let [searchText, setSearchText] = useState("");
  function checkDataSourceType(dataSource) {
    if (Array.isArray(dataSource)) {
      return "Array";
    } else if (typeof dataSource === "object" && dataSource !== null)
      return "Object";

    return "";
  }

  function isActive(item) {
    let valueList = [];

    if (dataSourceType === "Object") {
      Object.keys(value).forEach(
        (key) => (valueList = [...valueList, ...value[key]])
      );
    } else if (dataSourceType === "Array") {
      valueList = value;
    }
    let isFound = valueList?.find(
      (value) => JSON.stringify(value) === JSON.stringify(item)
    );
    return isFound;
  }

  function findBy(compareBy, source, target) {
    let key = compareBy;
    let isFound = false;
    // eslint-disable-next-line array-callback-return
    source.every((item) => {
      if (item[key] && target[key]) {
        if (item[key] === target[key]) {
          isFound = true;
          return false;
        }
        return true;
      }
    });
    return isFound;
  }

  function checkisItemAlreadyFound({ key, item }) {
    let getList = [];

    if (dataSourceType === "Object") {
      getList = initialValues[key];
    } else if (dataSourceType === "Array") {
      getList = initialValues;
    }
    if (compareBy.length > 0 && getList) {
      return findBy(compareBy, getList, item);
    }
    if (getList && !compareBy.length > 0) {
      let isFound = getList.find(
        (value) => JSON.stringify(value) === JSON.stringify(item)
      );
      if (isFound) {
        return true;
      }
    }
    return false;
  }

  return (
    <div className={styles.wrapper}>
      {onSearch && (
        <SearchWidget
          onSearch={(value) => {
            setSearchText(value);
            onSearch(value);
          }}
          searchAutoFocus={searchAutoFocus}
        />
      )}
      <DropDownWrapper>
        <div>
          {dataSourceType === "Object" && (
            <div>
              {isEmpty(searchText) && !isEmpty(initialValues) && (
                <div className={styles.initialValuesWrapper}>
                  {Object.keys(initialValues)?.map((key, index) => {
                    return (
                      <div key={index}>
                        {initialValues[key]?.map((item, index) => {
                          if (!item) {
                            return null;
                          }
                          return (
                            <ListItem
                              labelRenderer={labelRenderer}
                              item={item}
                              key={index}
                              active={isActive(item)}
                              onClick={() => onChange(key, item)}
                              value={value}
                            />
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              )}
              {Object.keys(dataSource)?.map((key, index) => {
                return (
                  <div key={index}>
                    <p className={`tiny600 ${styles.groupName}`}>{key}</p>
                    {dataSource[key]?.map((item, index) => {
                      if (checkisItemAlreadyFound({ key, item })) {
                        return null;
                      }
                      return (
                        <ListItem
                          labelRenderer={labelRenderer}
                          item={item ? item : "N/A"}
                          key={index}
                          active={isActive(item)}
                          onClick={() => onChange(key, item)}
                          value={value}
                        />
                      );
                    })}
                  </div>
                );
              })}
            </div>
          )}
          {dataSourceType === "Array" && (
            <div>
              {isEmpty(searchText) && !isEmpty(initialValues) && (
                <div className={styles.initialValuesWrapper}>
                  {initialValues.map((item, index) => {
                    return (
                      <ListItem
                        labelRenderer={labelRenderer}
                        item={item ? item : "N/A"}
                        key={index}
                        active={isActive(item)}
                        onClick={() => onChange(item)}
                        value={value}
                      />
                    );
                  })}
                </div>
              )}
              {dataSource.map((item, index) => {
                if (checkisItemAlreadyFound({ item })) {
                  return null;
                }
                return (
                  <ListItem
                    labelRenderer={labelRenderer}
                    item={item ? item : "N/A"}
                    key={index}
                    active={isActive(item)}
                    onClick={() => onChange(item)}
                    value={value}
                  />
                );
              })}
            </div>
          )}
          {isEmpty(dataSource) && <NoResultsFound searchText={searchText} />}
        </div>
      </DropDownWrapper>
    </div>
  );
}

MultiSelectWidget.defaultProps = {
  compareBy: ""
};

MultiSelectWidget.propTypes = {
  // We can't define shape here because data is coming dynamic key.
  // It means Users: {Name:""} or Groups: {Name:""}
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onSearch: PropTypes.func,
  labelRenderer: PropTypes.func,
  dataSource: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  onChange: PropTypes.func,
  searchAutoFocus: PropTypes.func,
  compareBy: PropTypes.string
};

function ListItem(props) {
  let { onClick, active, labelRenderer, item } = props;
  let { disabled = false } = item;

  return (
    <div
      onClick={() => {
        if (onClick) {
          if (!disabled) {
            onClick();
          }
        }
      }}
      className={`${disabled && styles.disabled} ${styles.listItem}`}
    >
      <Checkbox checked={active} value={active} />
      <div className={`base`}>{labelRenderer(item)}</div>
    </div>
  );
}

ListItem.propTypes = {
  onClick: PropTypes.func,
  active: PropTypes.bool,
  labelRenderer: PropTypes.func,
  item: PropTypes.shape({
    disabled: PropTypes.bool,
    Kind: PropTypes.string,
    Name: PropTypes.string,
    _id: PropTypes.string
  })
};
